type PositionRanks = {
    [key: string]: number;
};

export const positionRanks: PositionRanks = {
    "SC": 1,
    "Supervisor": 2,
    "Program Manager": 3,
    "Owner": 4,
    "Executive Director": 5,
};